var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userflow)?_c('div',[_c('v-btn',{attrs:{"width":"290","color":"primary","disabled":_vm.disabled},on:{"click":_vm.openAdditionalQuiz}},[_vm._v("answer additional questions")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }